var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDueTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 10C3.3335 13.6819 6.31826 16.6667 10.0002 16.6667C13.6821 16.6667 16.6668 13.6819 16.6668 10C16.6668 6.31814 13.6821 3.33337 10.0002 3.33337C6.31826 3.33337 3.3335 6.31814 3.3335 10ZM8.95207 11.6191L13.2982 7.06838C13.5366 6.81875 13.9322 6.80965 14.1818 7.04805C14.4315 7.28645 14.4406 7.68208 14.2022 7.9317L9.42701 12.9317C9.18964 13.1802 8.79613 13.1905 8.54614 12.9547L5.82127 10.384C5.57019 10.1471 5.55867 9.75159 5.79554 9.50051C6.03241 9.24943 6.42797 9.23791 6.67905 9.47478L8.95207 11.6191Z",
    fill: "#8F90A6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueTask);
export default __webpack_public_path__ + "static/media/DueTask.a96745ae7bbd7ea6fb59dd732e37f53b.svg";
export { ForwardRef as ReactComponent };